import React, { createContext, useState, useContext, useEffect } from 'react';
import { Toast } from '@shopify/polaris';
import { setToastContext } from '../utils/toastUtils';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toast, setToast] = useState({
    active: false,
    content: '',
    error: false,
    duration: 3000
  });

  const showToast = (content, error = false, duration = error ? null : 3000) => {
    setToast({
      active: true,
      content,
      error,
      duration
    });
  };

  const dismissToast = () => {
    setToast(prev => ({
      ...prev,
      active: false
    }));
  };

  // Set the toast context in the global window object for use with toastUtils
  useEffect(() => {
    setToastContext({ showToast });
  }, []);

  return (
    <ToastContext.Provider value={{ toast, showToast, dismissToast }}>
      {children}
      {toast.active && (
        <Toast
          content={toast.content}
          error={toast.error}
          duration={toast.duration}
          onDismiss={dismissToast}
        />
      )}
    </ToastContext.Provider>
  );
}
